import React from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import { Button, Flex, Group, Stack } from '@mantine/core'

import { AttendeeForm } from '@/components/Event/NewScript/components/common/forms/AttendeeForm'
import { SubtleButton } from '@/components/Event/NewScript/components/common/Layout/SubtleButton'
import { getEditedAttendeeFieldPaths } from '@/components/Event/NewScript/utils/attendees'
import { EventType } from '@/constants'
import { ScriptAttendee, ZoomParticipant } from '@/types'

type Props = {
  attendee: ScriptAttendee
  onCancelClick: () => void
  onSubmitClick: (attendee: ScriptAttendee) => void
  zoomParticipants: ZoomParticipant[]
  timezone: string
  eventType: EventType
  isWitnessLocationEnabled: boolean
  namePrefix: string
  allAttendees: ScriptAttendee[]
}

export const AttendeeCardEdit: React.FC<Props> = ({
  attendee,
  onSubmitClick,
  onCancelClick,
  zoomParticipants,
  timezone,
  eventType,
  isWitnessLocationEnabled,
  namePrefix,
  allAttendees,
}) => {
  const methods = useFormContext()

  const onSubmitClickHandler = async () => {
    const fieldsToValidate = getEditedAttendeeFieldPaths(
      namePrefix,
      isWitnessLocationEnabled,
    )
    const results = await Promise.all(
      fieldsToValidate.map(field => methods.trigger(field)),
    )
    const isValid = results.every(result => result)
    if (isValid) {
      onSubmitClick({
        ...attendee,
        ...methods.getValues(namePrefix),
      })
    }
  }

  return (
    <Stack align="stretch">
      <FormProvider {...methods}>
        <AttendeeForm
          timezone={timezone}
          zoomParticipants={zoomParticipants}
          eventType={eventType}
          namePrefix={namePrefix}
          isWitnessLocationEnabled={isWitnessLocationEnabled}
          witnessRole="locked"
          allAttendees={allAttendees}
        />
        <Flex align="flex-start">
          <Group>
            <Button
              variant="filled"
              color="primary.2"
              onClick={onSubmitClickHandler}
            >
              Save changes
            </Button>
            <SubtleButton onClick={onCancelClick}>Cancel</SubtleButton>
          </Group>
        </Flex>
      </FormProvider>
    </Stack>
  )
}
